export default __webpack_public_path__ + "static/media/ethical.f70b6f8c.jpg";